import * as z from 'zod';
export const ErrorResponseSchema = z.object({
    error: z.string(),
    message: z.string(),
    details: z.looseObject({}).optional(),
});
//# sourceMappingURL=shared.js.map